import { wtUserApi } from 'api/clients';

import type { GenericResponse } from 'commons/modules/generic-response';

import {
  ApiResponse,
  adaptApiToGenericResponse,
  adaptErrorToGenericResponse,
} from '../shared';

import type { PermissionDataDto } from './dto';
import {
  mapPermissionDataDtoToModel,
  mapPermissionRequestModelToDto,
} from './mappers';
import type { PermissionData, PermissionRequest } from './models';

const mapPermissionResponseToApiResponse = (
  response: ApiResponse<PermissionDataDto>,
): ApiResponse<PermissionData> => ({
  ...response,
  pagination: null,
  data: mapPermissionDataDtoToModel(response.data),
});

export const getPermissionById = async (): Promise<
  GenericResponse<ApiResponse<PermissionData>>
> => {
  try {
    const response = await wtUserApi.get<ApiResponse<PermissionDataDto>>(
      '/management/permissions/id',
    );

    const mappedResponse = mapPermissionResponseToApiResponse(response.data);

    return adaptApiToGenericResponse(mappedResponse, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al obtener información',
    );
  }
};

export const savePermission = async (
  body: PermissionRequest,
): Promise<GenericResponse<ApiResponse<PermissionData>>> => {
  try {
    const response = await wtUserApi.post<ApiResponse<PermissionDataDto>>(
      '/management/permissions',
      mapPermissionRequestModelToDto(body),
    );

    const mappedResponse = mapPermissionResponseToApiResponse(response.data);

    return adaptApiToGenericResponse(mappedResponse, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(error, 'Ocurrió un error al guardar');
  }
};

export const updatePermission = async (
  body: PermissionRequest,
): Promise<GenericResponse<ApiResponse<PermissionData>>> => {
  try {
    const response = await wtUserApi.put<ApiResponse<PermissionDataDto>>(
      '/management/permissions',
      mapPermissionRequestModelToDto(body),
    );

    const mappedResponse = mapPermissionResponseToApiResponse(response.data);

    return adaptApiToGenericResponse(mappedResponse, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(error, 'Ocurrió un error al actualizar');
  }
};
